import React, { Children, ReactElement } from 'react';
import { styled } from 'styled-components';

import { ActionListWrapper } from './styles';
import { ActionListProps } from './types';

const ActionList = ({ children, className, isMuted, mobileVariant, testId }: ActionListProps) => {
  return (
    <ActionListWrapper className={className} $isMuted={isMuted} $mobileVariant={mobileVariant} data-testid={testId}>
      {Children.map(children, (child) => child)
        // Filter for empty children
        ?.filter((child) => React.isValidElement(child))
        .map((child, index) => (
          <li key={index}>
            {React.cloneElement(child as ReactElement<{ muted?: boolean; showAsButton?: boolean }>, {
              muted: isMuted,
              showAsButton: mobileVariant === 'round',
            })}
          </li>
        ))}
    </ActionListWrapper>
  );
};

export default styled(ActionList)``;
